import { Container } from '@mui/material'
import { Icon } from './icons'

export function LoadingComponent() {
	return (
		<Container sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
			<Icon name="loader" />
		</Container>
	)
}
